import React from 'react';
import TimezoneSelect, { ITimezone } from 'react-timezone-select';
import styles from './TimeZoneSelector.module.css';

export interface SelectTimeZoneProps {
  timezone: ITimezone,
  setTimezone: (value: ITimezone) => void,
  label: string,
  required?: boolean,
}

const TimezoneSelector: React.FC<SelectTimeZoneProps> = ({
  timezone,
  setTimezone,
  label,
  required,
}) => {
  return (
    <div>
      {label && <label className={styles.InputLabel}>{label + (required ? "*" : "")}</label>}
      <TimezoneSelect value={timezone} onChange={setTimezone}/>
    </div>
  );
};
export default TimezoneSelector;
